import React from 'react'
import { DataCard } from './styles'

export default function EmptyDataCard({text ,containerStyle}:{text:string,containerStyle?:string}) {
  return (
    <DataCard data-testid="test-empty-card" className={`bg-[#EBEBEB] ${containerStyle}`}>
      <div className='flex flex-col w-full'>

        <span className='text-darkGray text-base font-semibold pt-1'>{text}</span>
        <span className='text-sm mt-3 text-center text-[#474747]'>Não há registros</span>
      </div>
    </DataCard>
  )
}
